import React from 'react'
import * as config from '../../../settings/global';
import { DEBUG, HASH } from '../../../settings/global';
import { SOCIAL_DATA } from "../../../settings/content/socialProviders";
import { createFetch } from "../../../helpers/fetch/FetchRequest";
import { store } from "../../../redux/store";
import styles from "./ProviderAuth.module.scss";
import { dispatchNotification } from "../../../layouts/app/components/notificationSystem/notifications";
import { API_LOGIN_SOCIAL_EXTERNAL } from "../../../settings/endpoints/user";

export default function ProviderAuth({loading, setLoading}) {

    const authorize = provider => {

        if (loading) return;

        let LAST_STATE = localStorage.getItem(config.LAST_STATE_STORAGE_NAME);
        let data = {
            'hash': HASH,
            'redirect_url': LAST_STATE ? JSON.parse(LAST_STATE)['url'] : '/dashboard',
        };

        window.localStorage.setItem('hash', HASH);

        createFetch({
            method: 'POST',
            URL: API_LOGIN_SOCIAL_EXTERNAL + provider,
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data),
            onSuccess: data => {

                const response_status = data._status;

                if (response_status === "OK") {
                    const authorize_url = data.url_access_confirm;
                    location.assign(authorize_url);
                }
                // setCookie(config.USER_ACCESS_TOKEN_NAME, getCookie(config.USER_ACCESS_TOKEN_NAME));
                setLoading(true)
            },
            onError: response => {
                dispatchNotification({
                    message: 'An error occurred. Please, try again later, or contact support',
                    type: 'error',
                });
                setLoading(false);
            }
        })
    };

    const renderSocialIcons = () => {

        return SOCIAL_DATA.map((social, index) => {

            const {code, name, color, icon, excludeFromProviders, disabled} = social;
            let style = {'--iconColor': typeof color === 'string' ? color : store.getState().UI.theme.dark && !!color?.[1] ? color?.[1] : color?.[0]};

            if (loading) style = {'--iconColor': 'var(--colorFontLight)'};

            if (!excludeFromProviders && (DEBUG || !disabled)) return (
                <div className={styles['social__icon']} key={index}>
                    <button
                        type="button"
                        title={name}
                        style={style}
                        className={styles['social__icon__button']}
                        aria-label={`Authorise via ${name}`}
                        onClick={e => authorize(code, e)}
                    >
                        <i
                            className={`fab fa-${icon} ${styles['social__icon__button__provider']}`}
                            aria-hidden="true"
                        />
                        <i
                            className={`fas fa-sign-in-alt ${styles['social__icon__button__sign']}`}
                            aria-hidden="true"
                        />
                    </button>
                </div>
            )
        });
    };

    return (
        <div className={styles['social']}>
            {renderSocialIcons()}
        </div>
    );
}